var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.isOnline)?_c('div',{staticClass:"version online"},[_c('i',{staticClass:"fa fa-wifi"}),_vm._v(" Version: "+_vm._s(_vm.version)+" ")]):_vm._e(),(_vm.isOffline)?_c('div',{staticClass:"version offline"},[_c('i',{staticClass:"fa fa-minus-circle"}),_vm._v(" Version: "+_vm._s(_vm.version)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }